<div class="messages-page">
  <div class="d-flex">
    <div class="overflow-hidden flex-fill d-block position-relative">
      <div class="row messages-container" #conversationFilesView [ngStyle]="{ 'padding-bottom': inputContainerHeight + 'px' }">
        <div class="col-md-12 h-full">
          <div
            ng2FileDrop
            class="discussion-files-view timeline-drop-zone"
            [class.hovering]="hasBaseDropZoneOver"
            (onFileDrop)="droppedFile($event)"
            [uploader]="uploader"
            (fileOver)="fileOverBase($event)"
          >
            <div [class.visible]="typingUsers && typingUsers.length" class="users-typing d-flex justify-content-center align-items-center">
              @if (typingUsers && typingUsers.length) {
                <div class="m-r-10">{{ "sphere.workspaces.typing" | translate }}:</div>
              }
              @for (id of typingUsers; track id) {
                <div class="m-r-10 typing-user">
                  <img
                    [src]="thread.connection.photoURL ? thread.connection.photoURL : './assets/images/default_avatar.jpg'"
                    style="width: 20px; height: 20px; border-radius: 10px; margin-right: 5px"
                  />
                  {{ thread.connection.firstName }}
                </div>
              }
            </div>
            <div class="h-full">
              @if (loadingConversation && uiMeasured) {
                <div class="d-flex justify-content-center align-items-center t-30 h-full">
                  <myp-inline-loader [loading]="true" height="200px" spinnerName="conversationLoader"></myp-inline-loader>
                </div>
              }
              <div class="h-full">
                <div #chatWindow class="discussion-container h-full no-bg" [ngStyle]="{ 'border-radius': '10px 10px 0px 0px' }" [class.archived]="archivedDate">
                  @if (!loadingConversation && (!communityService.activeThreadMessages || !communityService.activeThreadMessages?.length)) {
                    <div class="h-full w-full d-flex align-items-center text-center justify-content-center">{{ "com.empty_thread_message" | translate }}</div>
                  }
                  @if (!showingAllMessages && !loadingConversation) {
                    <div class="text-center">
                      @if (communityService.activeThreadMessages?.length == 100) {
                        <button class="small-btn" (click)="initMessages(true)">{{ "com.get_older_messages" | translate }}</button>
                      }
                    </div>
                  }
                  @for (msg of communityService.activeThreadMessages; track msg) {
                    @if (msg.type == "message") {
                      <div class="msg-container" [class.me]="msg.author.id == user.id" [class.them]="msg.author.id != user.id">
                        <img [src]="msg.author.photo || './assets/images/default_avatar.jpg'" class="profile-photo pointer" [routerLink]="['../../profile', msg.author.id]" />
                        <div class="msg">
                          @if (msg.type == "message" && msg.message) {
                            <span class="text" [innerHTML]="msg.htmlMessage | safe: 'html'"></span>
                          }
                          @if (workspaceService.imageFiles[msg.file?.extension.toLowerCase()]) {
                            <div [class.m-t-10]="msg.message" class="m-b-5" *inView>
                              <img [src]="msg.file.url" class="image-border pointer" (click)="showImage(msg.file.url)" style="max-height: 300px" />
                            </div>
                          }
                          <span class="timestamp d-block">
                            {{ msg.timestamp?.seconds * 1000 | date: "MMM Do [at] hh:mm" : true }} &nbsp;
                            @if (msg.author.id != user.id) {
                              <span>{{ (thread.connection?.firstName + ' ' + thread.connection?.lastName) }}&nbsp;</span>
                            }
                            @if (msg.edited) {
                              <span class="c-gray">{{ "com.edited" | translate }}&nbsp;&nbsp;</span>
                            }
                            @if (msg.author.id == user.id) {
                              <span class="msg-options-link" (click)="msgOptions(msg)">{{ "sphere.options" | translate }}</span>
                            }
                          </span>
                        </div>
                      </div>
                    }
                    @if (msg.type == "notification" && msg.notificationType == "workspace_invite") {
                      <div style="margin: 100px 0px">
                        <div class="text-center">
                          <div class="d-flex justify-content-center">
                            <img [src]="msg.author.photo || './assets/images/default_avatar.jpg'" class="profile-photo pointer" [routerLink]="['../../profile', msg.author.id]" />
                            <div class="timestamp d-block text-left">
                              <span class="t-12 text-muted">{{ (msg.author.id == user.id ? (user.firstName + ' ' + user.lastName) : (thread.connection?.firstName + ' ' + thread.connection?.lastName)) }} - {{ msg.timestamp?.seconds * 1000 | date: "MMM Do [at] hh:mm" : true }}</span>
                              <br />
                            </div>
                          </div>
                          @if (msg.author.id == user.id) {
                            <span class="brandfont-bold">
                              {{ "com.you_invited_messages" | translate: { name: thread.connection.firstName, workspace_name: msg.workspace?.name } }}
                            </span>
                          }
                          @if (msg.author.id != user.id) {
                            <span class="brandfont-bold">
                              {{ "com.invited_you_messages" | translate: { name: (thread.connection?.firstName + ' ' + thread.connection?.lastName), workspace_name: msg.workspace?.name } }}
                            </span>
                          }
                          @if (msg.author.id != user.id && !msg.accepted) {
                            <div class="d-flex justify-content-center m-t-20">
                              <button class="btn btn-primary m-x-10" (click)="handleCollabInvite(true, msg)">{{ "com.accept_invite" | translate }}</button>
                              <button class="btn btn-danger m-x-10" (click)="handleCollabInvite(true, msg)">{{ "com.reject_invite" | translate }}</button>
                            </div>
                          }
                          @if (msg.accepted) {
                            <div class="d-flex justify-content-center m-t-20">
                              <fa-icon icon="check" class="c-green"></fa-icon>
                              &nbsp;&nbsp;&nbsp; {{ "com.accepted_on" | translate: { date: (msg.accepted?.seconds * 1000 | date) } }}
                            </div>
                          }
                          @if (msg.rejected) {
                            <div class="d-flex justify-content-center m-t-20">
                              <fa-icon icon="times" class="c-red"></fa-icon>
                              &nbsp;&nbsp;&nbsp;{{ "com.rejected_on" | translate: { date: (msg.accepted?.seconds * 1000 | date) } }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
                @if (archivedDate) {
                  <div class="archived-notice">Archived {{ archivedDate | date: "MMM Do [at] hh:mm" : true }}. Send a message to unarchive.</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (activeAttachment) {
        <div class="thread-pending-file-attachment">
          @if (activeAttachment.completed) {
            <div class="p-10">
              {{ "com.attached_file" | translate }}
              <br />
              <span class="text-muted t-14">{{ activeAttachment.filename }}</span>
            </div>
          }
          @if (!activeAttachment.completed) {
            <div class="w-100 position-relative">
              <span class="text-muted t-14">{{ "general.uploading" | translate }}: {{ activeAttachment.filename }} {{ activeAttachment.progress }}%</span>
              <div class="tiny-progress-bar" [ngStyle]="{ width: (activeAttachment.progress ? activeAttachment.progress : 0) + '%' }"></div>
            </div>
          }
          @if (activeAttachment.completed && workspaceService.imageFiles[activeAttachment.extension.toLowerCase()]) {
            <img class="image-border pointer" (click)="showImage(activeAttachment.url)" [src]="activeAttachment.url" style="height: 100px" />
          }
          @if (activeAttachment.completed) {
            <div class="m-t-20">
              <span class="tiny-link red" (click)="activeAttachment = undefined">{{ "general.remove" | translate }}</span>
            </div>
          }
        </div>
      }
      @if (!loadingConversation) {
        <div class="msg-input fixed-bottom" [class.archived]="archivedDate">
          <myp-message-input
            #msgInput
            (returnPressed)="addMessage($event)"
            (loaded)="messageInputCmpLoaded($event)"
            type="span"
            [mentionSource]="false"
            [inputID]="'message_input'"
            [placeholder]="'com.ctrl_enter' | translate"
            (valueChanged)="messageValueChange($event)"
            (inputHeightChange)="messageContainerHeightChange($event)"
            [includeSendButton]="true"
            [includeAttachmentButton]="!activeAttachment"
            (attachmentBtnClicked)="addFile()"
          ></myp-message-input>
        </div>
      }
    </div>
  </div>
</div>
